import ElementConstants from '../../elements';

const PublicSitePaymentElements = {
    OPEN: {
        type: ElementConstants.PAYMENTS.OPEN,
        tag: 'input',
        placeholder: 'Title',
        label: 'Title',
        min: '',
        max: '',
        required: false,
        hint: '',
        attributes: {
            type: 'number',
            placeholder: ''
        },
        paymentElement: true,
        quantity: 0
    },
    MULTI_CHOICE: {
        type: ElementConstants.PAYMENTS.MULTI_CHOICE,
        label: 'Title',
        placeholder: 'Title',
        paymentRequired: true,
        hint: '',
        required: false,
        choices: [],
        customChoices: []
    },
    ITEM: {
        type: ElementConstants.PAYMENTS.ITEM,
        label: 'Title',
        placeholder: 'Title',
        cost: '0.00',
        stock: -1,
        imageUrl: '',
        imageAlt: '',
        optionsLabel: '',
        tag: 'select',
        minQuantity: "0",
        maxQuantity: "",
        hint: '',
        country: false,
        required: false,
        attributes: {
            placeholder: 'Please Select'
        },
        options: []
    }
}

export default PublicSitePaymentElements;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/elements/public-site/payments.js